import { useEffect, useRef, useState } from 'react'
import { Link, Outlet, useLocation, useNavigate, useParams } from 'react-router-dom'
import CurrUser from '../functions/UserAuth'
import { toast } from 'react-toastify'
import guideline_Store from '../store/guideline_store'
import Attend_Message_Modal from '../component/Attend_Message_Modal'

function Guideline_Page() {

  const currUser = CurrUser();

  const guidelines = guideline_Store((state) => state.guidelines)
  const getGuidelines = guideline_Store((state) => state.getGuidelines)
  const editGuideline = guideline_Store((state) => state.editGuideline)

  const [isAdd, setIsAdd] = useState(false)

  const navigate = useNavigate()

  // const token = supervisor?.token ?? '-1'
  useEffect(() => {
    getGuidelines()
  }, [])
  let credits = 0

  //#region variables
  const [show, setShow] = useState(false);
  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);
  let [studentNote, setStudentNote] = useState('')
  let [supervisorNote, setSupervisorNote] = useState('')
  let [studentEdit, setStudentEdit] = useState(false)


  const execFunc = async () => {
    let result
    try {
      const note = studentEdit ? studentNote : supervisorNote

      if (note == '') {
        toast.error('Failed, Input box should not be empty!')
        return
      }
      const id = studentEdit ? 2 : 1
      const payload = { note }
      result = await editGuideline(payload, id)

      if (result?.status == 200 || result?.status == 201) {
        let msg = 'The request rejected successfully'
        toast.success(msg)
        // disappear modal
        setIsAdd(false)
      }
    } catch (error) {
      const errmsg = error.response?.data?.message
      if (!errmsg)
        return

      // show error reason as an error toast 
      if (Array.isArray(errmsg)) {

        errmsg.forEach((element, index) => {
          setTimeout(function () {
            toast.error(element)
          }, 200 * index);
        });
      } else {
        toast.error(errmsg)
      }

    }

  }

  const title = 'Change ' + (studentEdit ? 'student' : 'advisor') + ' guideline'
  return (
    <>
      {((guidelines?.data?.[0]?.note ?? '') == '') || ((guidelines?.data?.[1]?.note ?? '') == '') ? '' :
        <div>
          {currUser != 'student' &&
            < div className="card text-dark bg-light mb-3" >
              <div className="card-header">Advisor guideline</div>
              <div className="card-body pt-3">
                <div
                  dangerouslySetInnerHTML={{
                    __html: supervisorNote != '' ? supervisorNote : (guidelines?.data?.[0]?.note ?? ''),
                  }}

                />
              </div>
              {currUser == 'admin' &&
                <button onClick={() => {
                  setStudentEdit(false)
                  setIsAdd(true)
                }} className="btn border btn-outline-warning btn-md" type="button">
                  <i className="bi bi-pencil"></i>
                  <span className='ps-1'>Edit</span>
                </button>
              }
            </div>
          }
          <br />
          <br />

          {currUser != 'supervisor' &&
            <div className="card text-dark bg-light mb-3" >
              <div className="card-header">Student guideline</div>
              <div className="card-body pt-3">
                <div
                  dangerouslySetInnerHTML={{
                    __html: studentNote != '' ? studentNote : (guidelines?.data?.[1]?.note ?? ''),
                  }}
                />
              </div>
              {currUser != 'student' &&
                <button onClick={() => {
                  setStudentEdit(true)
                  setIsAdd(true)
                }} className="btn border btn-outline-warning btn-md" type="button">
                  <i className="bi bi-pencil"></i>
                  <span className='ps-1'>Edit</span>
                </button>
              }
            </div>
          }

          {/* Add & Edit Modal  */}
          <Attend_Message_Modal title={title} newNote={studentEdit ? studentNote : supervisorNote} setNewNote={studentEdit ? setStudentNote : setSupervisorNote} setIsAdd={setIsAdd} isOpen={isAdd} execFunc={execFunc} />
        </div>
      }
    </>
  )
}

export default Guideline_Page
